import { AiOutlineCloseCircle } from "react-icons/ai";
import { useStores } from "../../../store";
import { useObserver } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import { apiGet, apiPostPut } from "../../../api/api_methods";
import {
  getLabels,
  updateLabelsForCandidates,
} from "../../../api/recruiterLabelsApi";
import { toJS } from "mobx";
import { useNavigate } from "react-router-dom";
import LabelPopup from "./LabelPopup";

export default function ApplicantLabelPopup(props) {
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);
  const page = Number(query.get("page")) || 0;
  const { LabelStore, RecuiterStore, MockStore, PopupStore } = useStores();
  const bodyRef = useRef({
    id: LabelStore?.ApplicantId,
    section:
      LabelStore?.section === "jobPost" ? "application" : LabelStore?.section,
    add: [],
    remove: [],
  });
  const [selectedTagId, setSelectedTagId] = useState(null);

  useEffect(() => {
    bodyRef.current.id = LabelStore?.ApplicantId;
    bodyRef.current.section =
      LabelStore?.section === "jobPost" ? "application" : LabelStore?.section;
  }, [LabelStore?.ApplicantId, LabelStore?.section]);

  useEffect(() => {
    if (!LabelStore.Applicants) return;
    const arr = toJS(LabelStore.ApplicantLabelArray) || [];
    setSelectedTagId(arr.length ? arr[0] : null);
    bodyRef.current.add = [];
    bodyRef.current.remove = [];
  }, [LabelStore.Applicants, LabelStore.ApplicantId]);

  useEffect(() => {
    // jobPostsData();

    if (!LabelStore.applicationLabelFetch) {
      fetchlabelsData().then(() => {
        LabelStore.setApplicationLabelFetch(true);
      });

      console.log("body: ", bodyRef.current);
    }
  }, []);
  const fetchlabelsData = async () => {
    if (!LabelStore.applicationLabelFetch) {
      try {
        const response = await getLabels();
        if (response.status === 200 && response.body.success) {
          console.log(response.body.data);
          response.body.data.map((item, index) => {
            console.log(item.color);
          });
          // setFetchedLabels(response.body.data);
          LabelStore.setLabelsList(response.body.data);
          LabelStore.setSelctedLabel(LabelStore.labels_list[0]._id);
          LabelStore.setSelectedLebelValues(LabelStore.labels_list[0]);
          LabelStore.setApplicationLabelFetch(true);
        } else {
          console.log(`Error fetching job data: ${response.body.message}`);
        }
      } catch (error) {
        // setError(`Error fetching job data: ${error.message}`);
        console.error("Error fetching job data:", error); // Log the detailed error
      }
    }
  };
  const updateTable = () => {
    const current = [...(toJS(LabelStore.ApplicantLabelArray) || [])];
    if (selectedTagId) {
      bodyRef.current.add = current.includes(selectedTagId)
        ? []
        : [selectedTagId];
      bodyRef.current.remove = current.filter((id) => id !== selectedTagId);
    } else {
      bodyRef.current.add = [];
      bodyRef.current.remove = [...current];
    }

    const postLabels = async () => {
      try {
        LabelStore.setLoader(true);

        const response = await updateLabelsForCandidates(bodyRef.current);

        if (response.status === 200 && response.body.success) {
          if (LabelStore.section === "resumeSorting") {
            RecuiterStore.fetchapplicants();
            RecuiterStore.fetchResumeScore(page * 10);
            LabelStore.setLoader(false);
            return;
          }
          RecuiterStore.fetchapplicants();
          await RecuiterStore.fetchApplicantDetails(bodyRef.current?.id);
          LabelStore?.setreportScreenRefresher();
          console.log("report set");
          console.log("body: ", bodyRef.current);
          console.log("label updated", response.body);
          if (LabelStore.section == "resumeSorting") {
            RecuiterStore.fetchapplicants();
            return;
          }
          if (LabelStore.currentSection == "redirect") {
            console.log("this is ID --> ", LabelStore.applicant_id_mock);
            await MockStore.getReport(LabelStore.applicant_id_mock);
            // console.log("navigating...")
            // console.log(`/company/mocktest-applicants/${LabelStore.applicant_id_mock}?mocktestId=${LabelStore.MockTestId}`)
            // console.log(LabelStore.MockTestId)
            // navigate(`/company/mocktest-applicants/${LabelStore.applicant_id_mock}?mocktestId=${LabelStore.MockTestId}`);
          }
        } else {
          console.log(`Error fetching job data: ${response.body.message}`);
        }
        RecuiterStore.setClientId();
        RecuiterStore.fetchapplicants();
        RecuiterStore.fetchResumeScore();

        LabelStore.setLoader2(!LabelStore.loader2);
        LabelStore.setLoader(false);

        LabelStore.setApplicantId(null);
      } catch (error) {
        console.error("Error fetching job data:", error); // Log the detailed error
        LabelStore.setLoader(false);
      }
    };
    postLabels();

    LabelStore.setApplicants(false);
    console.log("popup is set to: ", LabelStore.Applicants);
    // console.log("body: ", body);
  };

  const selectOrToggleTag = (item) => {
    if (selectedTagId === item._id) {
      setSelectedTagId(null);
      LabelStore.setApplicantColor("");
    } else {
      setSelectedTagId(item._id);
      LabelStore.setApplicantColor(item.color);
    }
  };

  return useObserver(() => (
    <>
      {LabelStore.Applicants ? (
        <div
          onClick={() => {
            LabelStore.setApplicants(false);
            LabelStore.setApplicantId(null);
          }}
          className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-0"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="absolute inset-0 z-50 m-auto flex h-fit max-h-[85vh] w-[90%] flex-col items-center overflow-y-auto rounded-3xl border bg-bg3 pb-3 no-scrollbar md:w-[20%] lg:w-[20%]"
          >
            <AiOutlineCloseCircle
              className="absolute text-xl cursor-pointer top-2 right-2"
              onClick={() => {
                //   PopupStore.setLabelPopup(false);
                LabelStore.setApplicants(false);
                LabelStore.setApplicantId(null);
              }}
            />
            <p className="text-3xl  mt-10 text-primary">Tags </p>
            <p className="mt-2 px-6 text-center text-sm text-gray-500">
              One tag per applicant. Click the same tag again to remove it.
            </p>
            <div className="mt-2 w-[80%] min-w-0 overflow-y-auto no-scrollbar max-h-[38vh]">
              {LabelStore?.labels_list?.filter((item) => !item.isDeleted)
                ?.length > 0 ? (
                LabelStore?.labels_list?.map(
                  (item) =>
                    !item.isDeleted && (
                      <div
                        key={item._id}
                        role="button"
                        tabIndex={0}
                        className="flex cursor-pointer items-center rounded-md py-0.5 hover:bg-gray-50/80"
                        onClick={() => selectOrToggleTag(item)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            selectOrToggleTag(item);
                          }
                        }}
                      >
                        <input
                          type="radio"
                          name="applicant-single-tag"
                          readOnly
                          tabIndex={-1}
                          style={{ accentColor: item.color }}
                          className="pointer-events-none mt-2 h-5 w-5 shrink-0"
                          checked={selectedTagId === item._id}
                        />
                        <p className="mt-2 px-2 text-sm">{item.name}</p>
                        <div
                          style={{ backgroundColor: item?.color }}
                          className="ml-auto mr-3 mt-2 h-5 w-5 shrink-0 rounded-full outline-none"
                          aria-hidden
                        />
                      </div>
                    ),
                )
              ) : (
                <p className=" my-10 ml-10 text-2xl">No tags found</p>
              )}
            </div>
            <div className="mt-3 flex w-[80%] items-center justify-between gap-4 border-t border-gray-200/80 px-0 pt-3">
              <button
                type="button"
                className="text-left text-sm font-medium text-gray-500 transition hover:text-primary"
                onClick={() => PopupStore.setLabelPopup(true)}
              >
                create a new tag
              </button>
              <button
                type="button"
                onClick={() => updateTable()}
                disabled={
                  !(
                    LabelStore?.labels_list?.filter((item) => !item.isDeleted)
                      ?.length > 0
                  ) ||
                  selectedTagId ===
                    (LabelStore?.ApplicantLabelArray?.length
                      ? LabelStore.ApplicantLabelArray[0]
                      : null)
                }
                className={`shrink-0 rounded-lg px-5 py-2 text-sm font-semibold text-white ${
                  !(
                    LabelStore?.labels_list?.filter((item) => !item.isDeleted)
                      ?.length > 0
                  ) ||
                  selectedTagId ===
                    (LabelStore?.ApplicantLabelArray?.length
                      ? LabelStore.ApplicantLabelArray[0]
                      : null)
                    ? "bg-gray-400 cursor-not-allowed opacity-60"
                    : "bg-primary"
                }`}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      ) : null}
      <LabelPopup />
    </>
  ));
}
